import { createTypes } from 'reduxsauce'
import { IComponentState, IPaginator } from '../root.types'
import { TypesUser } from '../../application/models/user/user'

export const UserTypes = createTypes(`
    RESET_CREATE 
    RESET_PAGINATOR
    
    CHANGE_USER 
    CHANGE_PAGINATOR
    CHANGE_SEARCH

    CREATE_USER_REQUEST
    CREATE_USER_SUCCESS
    CREATE_USER_FAILURE

    LOAD_USER_REQUEST
    LOAD_USER_SUCCESS
    LOAD_USER_FAILURE

    FIND_USER_REQUEST
    FIND_USER_SUCCESS
    FIND_USER_FAILURE

    UPDATE_USER_REQUEST
    UPDATE_USER_SUCCESS
    UPDATE_USER_FAILURE

    REMOVE_USER_REQUEST
    REMOVE_USER_SUCCESS
    REMOVE_USER_FAILURE

    GET_USER_LOGGED_REQUEST
    GET_USER_LOGGED_SUCCESS
    GET_USER_LOGGED_FAILURE

    REMOVE_USER_LOGGED_REQUEST
    REMOVE_USER_LOGGED_SUCCESS
    REMOVE_USER_LOGGED_FAILURE
    
    CHANGE_AVATAR_FILE
    CHANGE_AVATAR_IMG
    LOAD_AVATAR_REQUEST
    LOAD_AVATAR_SUCCESS
    LOAD_AVATAR_FAILURE
    REMOVE_AVATAR_REQUEST
    REMOVE_AVATAR_SUCCESS
    REMOVE_AVATAR_FAILURE
    
`,
    {
        prefix: '@user/'
    }
)
export interface IUserState {
    readonly create: ICreateState
    readonly list: IListState
    readonly userLogged: IUserLogged
}

interface ICreateState extends IComponentState {
    readonly avatar: IAvatar
    readonly user: any
    readonly loadingAvatar: boolean
    readonly dataError: any
}
export interface IListState extends IComponentState {
    readonly users: any
    //   readonly avatars: IAvatarList[]
    readonly paginator: IPaginator
}
export interface IUserLogged extends IComponentState {
    readonly userLogged: any
}

export interface IActionFind {
    readonly userId: string
    readonly typeUser: TypesUser
}
export interface IActionUpdate {
    readonly user: any
    readonly avatar?: any
}
export interface IActionLoad {
    readonly typeUser: TypesUser
    readonly paginator?: IPaginator

}
export interface IActionRemove {
    readonly user: any
}

export interface IAvatar {
    readonly file?: File
    readonly img?: string
}